import React, { CSSProperties } from 'react';
import { useTheme } from '../../../../hooks/useTheme';

export interface ContractIconSvgProps {
  s?: CSSProperties;
}

export interface ContractIconProps {
  ariaTitle?: string;
  s?: CSSProperties;
  featureName?: string;
}

const ContractIconSVG = ({ ariaTitle, s }: ContractIconProps) => (
  <svg
    role={ariaTitle ? 'img' : 'presentation'}
    viewBox="0 0 16 16"
    style={{ width: '1rem', height: 'auto', fill: s?.color, ...s }}
  >
    {ariaTitle && <title>{ariaTitle}</title>}
    <path d="M0.171308 15.8284C0.36657 16.0237 0.683152 16.0237 0.878415 15.8284L4.97461 11.7322L4.97461 14.5C4.97461 14.7761 5.19847 15 5.47461 15C5.75075 15 5.97461 14.7761 5.97461 14.5L5.97461 10.5251C5.97461 10.249 5.75075 10.0251 5.47461 10.0251L1.49977 10.0251C1.22363 10.0251 0.999774 10.249 0.999774 10.5251C0.999774 10.8013 1.22363 11.0251 1.49977 11.0251L4.2675 11.0251L0.171308 15.1213C-0.0239541 15.3166 -0.0239541 15.6331 0.171308 15.8284Z" />
    <path d="M15.8287 0.171593C15.6334 -0.023669 15.3168 -0.0236691 15.1216 0.171593L11.0254 4.26779L11.0254 1.50001C11.0254 1.22387 10.8015 1.00001 10.5254 1.00001C10.2492 1.00001 10.0254 1.22387 10.0254 1.50001L10.0254 5.47489C10.0254 5.75104 10.2492 5.97489 10.5254 5.97489L14.5002 5.97489C14.7764 5.97489 15.0002 5.75103 15.0002 5.47489C15.0002 5.19875 14.7764 4.97489 14.5002 4.97489L11.7325 4.97489L15.8287 0.8787C16.024 0.683438 16.024 0.366855 15.8287 0.171593Z" />
  </svg>
);

const ContractIconThemed = ({ ariaTitle, s }: ContractIconProps) => {
  const { iconsPrimaryNone } = useTheme();
  return (
    <ContractIconSVG s={{ ...iconsPrimaryNone, ...s }} ariaTitle={ariaTitle} />
  );
};

const ContractIcon = ({
  themed = true,
  ...rest
}: ContractIconProps & { themed?: boolean }) =>
  themed ? <ContractIconThemed {...rest} /> : <ContractIconSVG {...rest} />;

export default ContractIcon;
